<template>
  <div class="container">
    <donut-page-title title="Uh-oh!" />
    <div class="separator m-vx2" />
    <div class="ta-c m-vx4">
      <div v-if="props.codeChars" class="f-ac f-jc">
        <div class="t-xxx gray bold m-r">{{ props.codeChars[0] }}</div>
        <template v-if="props.codeChars.length > 1">
          <cdn-img path="donut_face_sad_100" :version="1" />
          <div class="t-xxx gray bold m-l">{{ props.codeChars[1] }}</div>
        </template>
      </div>
      <div class="t-xl bold m-tx6">{{ props.subtitle }}</div>
      <slot />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    codeChars: { type: Array, default: null },
    subtitle: { type: String, default: 'Sorry about that!' },
  });
</script>
